import { useAuthStore } from '@/store/authStore';

/**
 * Returns the currency symbol and a price formatter based on the tenant's
 * selected currency (stored on the authenticated user).
 */
export function useCurrency() {
  const user = useAuthStore((s) => s.user);
  const code = user?.currency_code ?? 'USD';

  const symbol = new Intl.NumberFormat('en', {
    style: 'currency',
    currency: code,
    currencyDisplay: 'narrowSymbol',
  })
    .formatToParts(0)
    .find((p) => p.type === 'currency')?.value ?? code;

  const formatPrice = (amount: number) =>
    new Intl.NumberFormat('en', {
      style: 'currency',
      currency: code,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 2,
    }).format(amount);

  return { symbol, code, formatPrice };
}
